import DefaultPopup from './DefaultPopup';
import NonBlockingPopup from './NonBlockingPopup';

import styles from './Popups.module.scss';

const Popups = () => (
  <div className={styles['modal-root']}>
    <NonBlockingPopup />
    <DefaultPopup />
  </div>
);

export default Popups;
